import config from "../../../_config/config";
import axiosInstance from "../../../_helpers/axiosInstance";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";
import { bucketlistConstants } from "../../_constants";

//create new bucket List
export const create_bucketlist_data_action = (data) => async (dispatch) => {
  dispatch({
    type: bucketlistConstants.CREATE_BUCKET_LIST_DATA_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(
      config.mentor.createBucketList,
      data
    );
    if (response.status) {
      dispatch({
        type: bucketlistConstants.CREATE_BUCKET_LIST_DATA_ACTION_SUCCESS,
        payload: response.data,
      });
      showSuccessMessage("Bucket List Created Sucessfully.");
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: bucketlistConstants.CREATE_BUCKET_LIST_DATA_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e.msg);
  }
};

//deletes bucket
export const delete_bucket_list_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: bucketlistConstants.DELETE_BUCKET_LIST_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.delete(
        config.mentor.deleteBucketList.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: bucketlistConstants.DELETE_BUCKET_LIST_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: bucketlistConstants.DELETE_BUCKET_LIST_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
    }
  };

//All bucket list
export const get_bucket_list_data_by_id_action = (id) => async (dispatch) => {
  dispatch({
    type: bucketlistConstants.GET_BUCKET_LIST_DATA_BY_ID_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.mentor.viewBucketList.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: bucketlistConstants.GET_BUCKET_LIST_DATA_BY_ID_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: bucketlistConstants.GET_BUCKET_LIST_DATA_BY_ID_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

//All bucket list
export const get_all_bucket_list_data_action = () => async (dispatch) => {
  dispatch({
    type: bucketlistConstants.GET_ALL_BUCKET_LIST_DATA_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.mentor.getBucketList);
    if (response.status) {
      dispatch({
        type: bucketlistConstants.GET_ALL_BUCKET_LIST_DATA_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: bucketlistConstants.GET_ALL_BUCKET_LIST_DATA_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};

//assign interview to bucket List
export const assign_interview_to_bucket_list_data_action =
  (data) => async (dispatch) => {
    dispatch({
      type: bucketlistConstants.ASSIGN_INTERVIEW_TO_BUCKET_LIST_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.mentor.assignInterviewToKit,
        data
      );
      if (response.status) {
        dispatch({
          type: bucketlistConstants.ASSIGN_INTERVIEW_TO_BUCKET_LIST_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        showSuccessMessage("Bucket List Created Sucessfully.");
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: bucketlistConstants.ASSIGN_INTERVIEW_TO_BUCKET_LIST_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e.msg);
    }
  };

//All bucket list
export const get_bucketlist_candidate_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: bucketlistConstants.GET_BUCKET_LIST_CANDIDATES_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.mentor.getBucketCandiatesList.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: bucketlistConstants.GET_BUCKET_LIST_CANDIDATES_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: bucketlistConstants.GET_BUCKET_LIST_CANDIDATES_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };

//email bucket List
export const send_bucket_by_email_data_action = (data) => async (dispatch) => {
  dispatch({
    type: bucketlistConstants.SEND_BUCKET_BY_EMAIL_DATA_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(
      config.mentor.setBucketListByEmail,
      data
    );
    if (response.status) {
      dispatch({
        type: bucketlistConstants.SEND_BUCKET_BY_EMAIL_DATA_ACTION_SUCCESS,
        payload: response.data,
      });
      showSuccessMessage(response.data?.detail);
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: bucketlistConstants.SEND_BUCKET_BY_EMAIL_DATA_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e.msg);
  }
};
